import { Component, ElementRef, ViewChild } from '@angular/core';
import { MatDialog, MatPaginator, MatSnackBar, MatSort, MatTableDataSource } from '@angular/material';
import { EliminazioneComponent } from 'app/main/shared/alert/eliminazione/eliminazione.component';
import { AdminEditComponent } from '../admin-edit/admin-edit.component';

@Component({
  selector: 'app-admin-util',
  templateUrl: './admin-util.component.html',
  styleUrls: ['./admin-util.component.scss']
})
export class AdminUtilComponent {

  constructor(
    public dialog: MatDialog,
    private snackBar: MatSnackBar
  ) { }



  // Data variables
  data: Array<any> = [];
  banks: Array<any> = [];
  allBanks: Array<any> = [];



  // Table variables
  sort: any;
  @ViewChild(MatSort) set content(content: ElementRef) {
    this.sort = content;
    if (this.sort) {
      if (this.dataSource) {
        this.dataSource.sort = this.sort;
      }
    }
  }
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataSource: MatTableDataSource<any>;
  loading = true;

  // New edit or create dialog
  newDialog(data: any, callback: any, callback2?: any) {
    const dialog = this.dialog.open(AdminEditComponent, {
      width: '400px',
      panelClass: 'custom-panel-class',
      data: data,
    });

    dialog.componentInstance.onChangePassword.subscribe(() => {
      callback2();
    });

    dialog.afterClosed().subscribe((datas: any) => {
      if (datas) {
        callback(datas);
      }
    });
  }

  // New edit or create dialog
  newDialog2(data: any, afterClosedCallback: any, changePasswordCallback?: any, changeUsernameCallback?: any, sendingPushNotificationCallback?: any) {
    const dialog = this.dialog.open(AdminEditComponent, {
      width: '400px',
      panelClass: 'custom-panel-class',
      data: data,
    });

    if (changePasswordCallback) {
      dialog.componentInstance.onChangePassword.subscribe(() => {
        changePasswordCallback();
      });
    }

    if (changeUsernameCallback) {
      dialog.componentInstance.onChangeUsername.subscribe(() => {
        changeUsernameCallback();
      });
    }

    if (sendingPushNotificationCallback) {
      dialog.componentInstance.onSendingPushNotification.subscribe(() => {
        sendingPushNotificationCallback(dialog);
      });
    }

    dialog.afterClosed().subscribe((datas: any) => {
      if (datas) {
        afterClosedCallback(datas);
      }
    });
  }


  // Checks if there exists data
  checkData() {
    if (this.data) {
      return !this.loading && (this.data.length === 0);
    } else {
      return false;
    }
  }

  // New delete dialog
  newElimina(data: any, callback: any) {
    const dialog = this.dialog.open(EliminazioneComponent, {
      data: `${data}`,
    });
    dialog.afterClosed().subscribe((datas) => {
      if (datas && datas['data']) {
        callback(datas);
      } else {
        callback(null);
      }
    });
  }

  // Creates new data source for table and sets loading paginator and gets deleted banks
  async newDataSource(data: Array<any> = [], newData?: boolean) {
    /*this.banks = await data.map((res: any, index: any) => {
      if (res.deleted === false) {
        return res;
      }
    });*/
    this.dataSource = new MatTableDataSource(data);
    this.loading = false;
    if (this.dataSource) {
      if (this.sort) {
        this.dataSource.sort = this.sort;
      }
      if (this.paginator) {
        this.dataSource.paginator = this.paginator;
      }
    }
    if (newData) {
      this.data = data;
    }
  }

  // Creates new data source for table and sets loading paginator and gets deleted banks
  async newDataSource2(data: Array<any> = [], newData?: boolean, attachPaginator?: boolean) {
    /*this.banks = await data.map((res: any, index: any) => {
      if (res.deleted === false) {
        return res;
      }
    });*/
    this.dataSource = new MatTableDataSource(data);
    this.loading = false;
    if (this.dataSource) {
      if (this.sort) {
        this.dataSource.sort = this.sort;
      }
      if (attachPaginator && this.paginator) {
        this.dataSource.paginator = this.paginator;
      }
    }
    if (newData) {
      this.data = data;
    }
  }

  // New snackbar
  newSnackbar(text: any, snackBarClass: any) {
    return this.snackBar.open(`${text}`, '', {
      duration: 2000,
      panelClass: snackBarClass,
    });
  }

  // New delete dialog
  newConfirmation(data: any, callback: any) {
    const dialog = this.dialog.open(EliminazioneComponent, {
      // data: `${data}`,
      data: {
        newWay: true,
        title: 'Conferma Operazione',
        body: 'Sei sicuro?'
      }

    });
    dialog.afterClosed().subscribe((datas) => {
      if (datas && datas['data']) {
        callback(datas);
      } else {
        callback(null);
      }
    });
  }

}

